module.exports = __webpack_public_path__ + "static/wrkat-extraimg2@2x-min-74fa3fe333e1078fa0d7d55d3efb14d4.png";